
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreens as ObiScreensElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screens.js';
 
 
 

 
 export const ObiScreens = createComponent({
   react: React,
   tagName: 'obi-screens',
   elementClass: ObiScreensElement,
   events: {
     
   }
  });
 
 